// Globals
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// Models
import { ROUTES } from '@/models/router.model';
import { IAdminProfileResponse } from '@/models/admins.model';

// Components
import { CrossIcon, EditIcon, ResendIcon } from '@/icons';
import { StyledActionButton, StyledButtonsWrap } from '../Styled';
import { COLORS } from '@/theme';

interface IAdminTableActions {
  id: string;
  setDeletedAdmin: (admin: IAdminProfileResponse) => void;
  onResendInvitation: (id: string) => void;
  record: IAdminProfileResponse;
}

const AdminTableActions = ({ id, setDeletedAdmin, onResendInvitation, record }: IAdminTableActions) => {
  const navigate = useNavigate();
  const { type } = useParams<{ type: string; id?: string }>();

  const onEdit = () => {
    navigate(`${ROUTES.USERS_LIST_INDEX}/${type}/${decodeURIComponent(id)}`);
  };

  const handleDelete = () => setDeletedAdmin(record);

  return (
    <StyledButtonsWrap>
      {record.invitation_expired && (
        <StyledActionButton $color={COLORS.BLUE} onClick={() => onResendInvitation(id)}>
          <ResendIcon />
        </StyledActionButton>
      )}
      <StyledActionButton onClick={onEdit} $color={COLORS.GREEN}>
        <EditIcon />
      </StyledActionButton>
      <StyledActionButton $color={COLORS.RED} onClick={handleDelete}>
        <CrossIcon />
      </StyledActionButton>
    </StyledButtonsWrap>
  );
};

export default AdminTableActions;
